// import React, { useEffect, useState, useContext } from "react";
import React from "react";
// import { AuthContext } from "../../shared/context/auth-context";
// import { Link } from "react-router-dom";
import Card from "../../shared/components/UIElements/Card";

import TradeItem from "./TradeItem";
import "./TradeList.css";

const TradeList = ({ data, onTradeClick, selectedTrade }) => {
  // Prices and profit in USD at each day's rate; the backend says if a trade
  // stayed in its quote currency for want of a rate
  const currency = data?.find((trade) => trade.currency)?.currency || "USD";
  return (
    <React.Fragment>
      <Card className="trade-list-header">
        <table className="trade-table">
          <tbody>
            <tr>
              <th>Trade Number</th>
              <th>Buy Date</th>
              <th>Buy Price [{currency}]</th>
              <th title="Entry and re-buys averaged; the profit is based on it">Avg Price [{currency}]</th>
              <th>Re-buys</th>
              <th>Sell Date</th>
              <th>Sell Price [{currency}]</th>
              <th>Hold Duration</th>
              <th>Price Max [{currency}]</th>
              <th>Price Min [{currency}]</th>
              <th>MDD [%]</th>
              <th>Profit [%]</th>
            </tr>
          </tbody>
        </table>
      </Card>
      <div>
        <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
          {/* The highest trade number on top; the API returns them in storage order */}
          {data
            .slice()
            .sort((a, b) => Number(b.TRADE_NUMBER) - Number(a.TRADE_NUMBER))
            .map((trade) => (
              <TradeItem
                key={trade.TRADE_NUMBER}
                TRADE_NUMBER={trade.TRADE_NUMBER}
                DATE_BUY={trade.DATE_BUY}
                PRICE_BUY={trade.PRICE_BUY}
                PRICE_AVG={trade.PRICE_AVG}
                REBUY_COUNTER={trade.REBUY_COUNTER}
                DATE_SELL={trade.DATE_SELL}
                PRICE_SELL={trade.PRICE_SELL}
                HOLD_DUR={trade.HOLD_PERIOD}
                PRICE_MAX={trade.PRICE_MAX}
                PRICE_MIN={trade.PRICE_MIN}
                MDD={trade.MDD}
                PNL={trade.PNL_PER}
                onTradeClick={onTradeClick}
                isSelected={selectedTrade && selectedTrade.TRADE_NUMBER === trade.TRADE_NUMBER}
              />
            ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default TradeList;
